import * as React from 'react';
import { RootStore, withInjectedRootStore } from '../../../../providers';
import { ChangePlanModalBody } from './ChangePlanModalBody/ChangePlanModalBody';
import { ChangeDeclinePlanModalBody } from './ChangePlanModalBody/ChangeDeclinePlanModalBody';
import { ChangePlanSuccessModal } from './ChangePlanSuccessModal';
import { ChangePlanErrorModal } from './ChangePlanErrorModal';
import { ChangePlanModalContextProvider } from '../../ChangePlanModalContext';
import { Loader } from '@wix/design-system';
import { useChangePlanModal } from './useChangePlanModal';
import { SwitchPlanType } from 'enums';

interface ChangePlanModalLayoutProps {
  rootStore: RootStore;
}

const ChangePlanModalLayoutComp: React.FC<ChangePlanModalLayoutProps> = ({
  rootStore,
}) => {
  const { isDowngradePlanOfDeclineChargeService } = rootStore.appStore;
  const {
    isSuccessModal,
    isErrorModal,
    error,
    changePlanDetails,
    changePlanModalProps,
  } = useChangePlanModal(rootStore.appStore);

  const isInGracePeriod =
    !!changePlanDetails &&
    changePlanDetails.changePlanType === SwitchPlanType.GracePeriod;
  const ModalBody = () =>
    isDowngradePlanOfDeclineChargeService ? (
      <ChangeDeclinePlanModalBody
        {...changePlanModalProps}
        isInGracePeriod={isInGracePeriod}
      />
    ) : (
      <ChangePlanModalBody {...changePlanModalProps} />
    );

  return isSuccessModal ? (
    <ChangePlanSuccessModal />
  ) : isErrorModal ? (
    <ChangePlanErrorModal errorType={error} />
  ) : changePlanDetails ? (
    <ChangePlanModalContextProvider changePlanDetails={changePlanDetails}>
      <ModalBody />
    </ChangePlanModalContextProvider>
  ) : (
    <div data-testid='modal-loader'>
      <Loader />
    </div>
  );
};

export const ChangePlanModalLayout = withInjectedRootStore(
  ChangePlanModalLayoutComp,
);
